import messageRequestedHandler from './messageRequested.handler';
import ctaRequestedHandler from './ctaRequested.handler';
import { HandlerPayload } from './typings';

export default ({ transport }: HandlerPayload) => {
  messageRequestedHandler({ transport });
  ctaRequestedHandler({ transport });
};
